import { createComponent } from '@carvana/merch-components';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import EarliestDelivery from '@/vdp/EarliestDelivery';
import Gallery from '@/vdp/Gallery';
import useShowKBBPromo from '@/vdp/StickyBanner/useShowKBBPromo';
import Sections from '~/constants/sections';
import { useGetShowEVTaxTreatment, usePriceDrop } from '~/hooks/vdp';
import { getIsWIPVehicle } from '~/selectors';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

const Wrapper = createComponent('div', {
  className: 'relative bg-grey-1'
});

const AboutThePrice = dynamic(
  () => import(/* webpackChunkName: "AboutThePrice" */ '@/vdp/AboutThePrice')
);

const GalleryAndDelivery = () => {
  const { showPriceDrop } = usePriceDrop();
  const isWIP = useSelector(getIsWIPVehicle);
  const showEVTaxTreatment = useGetShowEVTaxTreatment();
  const showKBBPromo = useShowKBBPromo();

  const showAboutPrice = showPriceDrop || showKBBPromo || showEVTaxTreatment;

  return isWIP ? null : (
    <Wrapper>
      <Gallery />
      {showAboutPrice && <AboutThePrice />}
      <EarliestDelivery />
    </Wrapper>
  );
};

export default withErrorBoundary(
  GalleryAndDelivery,
  undefined,
  undefined,
  Sections.Gallery
);
